import HttpService from './HttpService';


export const applicationsList = (customer_id, page, items, applicationTypeKey, searchKey, searchedVal, signal) => {
    const http = new HttpService();
   
    page = parseInt(page)+1;
    if (searchedVal.trim().length!=0){
        var url = "users/applications-list/" + customer_id + "?page=" + page + '&items=' + items + '&searchKey=' + searchKey + '&searchKeyValue=' + searchedVal + '&applicationTypeKey=' + applicationTypeKey;
    }else{
        var url = "users/applications-list/" + customer_id + "?page=" + page + '&items=' + items + '&applicationTypeKey=' + applicationTypeKey;
    }
    
    const tokenId = "user-token";
    return http.getData(url, tokenId, signal).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}
export const chalaniList = (customer_id, page, items, applicationTypeKey, searchKey, searchedVal, signal) => {
    const http = new HttpService();

    page = parseInt(page) + 1;
    if (searchedVal.trim().length != 0) {
        var url = "customer/chalanis-list/" + customer_id + "?page=" + page + '&items=' + items + '&searchKey=' + searchKey + '&searchKeyValue=' + searchedVal + '&applicationTypeKey=' + applicationTypeKey;
    } else {
        var url = "customer/chalanis-list/" + customer_id + "?page=" + page + '&items=' + items + '&applicationTypeKey=' + applicationTypeKey;
    }

    const tokenId = "user-token";
    return http.getData(url, tokenId, signal).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}
export const progressReportList = (customer_id, page, items, applicationTypeKey, searchKey, searchedVal, signal) => {
    const http = new HttpService();

    page = parseInt(page) + 1;
    if (searchedVal.trim().length != 0) {
        var url = "customer/progress-report-list/" + customer_id + "?page=" + page + '&items=' + items + '&searchKey=' + searchKey + '&searchKeyValue=' + searchedVal + '&applicationTypeKey=' + applicationTypeKey;
    } else {
        var url = "customer/progress-report-list/" + customer_id + "?page=" + page + '&items=' + items + '&applicationTypeKey=' + applicationTypeKey;
    }

    const tokenId = "user-token";
    return http.getData(url, tokenId, signal).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}

export const relayList = (customer_id, page, items, applicationTypeKey, searchKey, searchedVal) => {
    const http = new HttpService();
    page = parseInt(page) + 1;
    if (searchedVal.trim().length != 0) {
        var url = "users/comments-list/" + customer_id + "?page=" + page + '&items=' + items + '&searchKey=' + searchKey + '&searchKeyValue=' + searchedVal + '&applicationTypeKey=' + applicationTypeKey;
    } else {
        var url = "users/comments-list/" + customer_id + "?page=" + page + '&items=' + items + '&applicationTypeKey=' + applicationTypeKey;
    }
    const tokenId = "user-token";
    return http.getData(url, tokenId).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}
export const updateRelayService = (credentials) => {
    const http = new HttpService();
    let url = "users/update-relay";
    const tokenId = "user-token";
    return http.postData(credentials, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}

export const updateApplicationService = (credentials) => {
    const http = new HttpService();
    let url = "users/update-application";
    const tokenId = "user-token";
    return http.postData(credentials, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}
export const storeRelayService = (credentials) => {
    const http = new HttpService();
    let url = "users/store-relay";
    const tokenId = "user-token";
    return http.postFormData(credentials, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}
export const storeChalaniService = (credentials) => {
    const http = new HttpService();
    let url = "users/store-chalani";
    const tokenId = "user-token";
    return http.postFormData(credentials, url, tokenId).then((data) => {

        return data;
    }).catch((error) => {
        return error;;
    })
}
export const storeProgressReportService = (credentials) => {
    const http = new HttpService();
    let url = "users/store-progress-report";
    const tokenId = "user-token";
    return http.postFormData(credentials, url, tokenId).then((data) => {

        return data;
    }).catch((error) => {
        return error;;
    })
}

export const updateRelayByRouteService = (credentials) => {
    const http = new HttpService();
    let url = "users/update-relay-by-route";
    const tokenId = "user-token";
    return http.postFormData(credentials, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}

export const updateApplicationByFieldsService = (credentials) => {
    const http = new HttpService();
    let url = "users/update-application-by-fields";
    const tokenId = "user-token";
    return http.postFormData(credentials, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;
    })
}
export const updateChalaniByObjectService = (credentials) => {
    const http = new HttpService();
    let url = "users/update-chalani-by-objects";
    const tokenId = "user-token";
    return http.postFormData(credentials, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;
    })
}
export const updateProgressReportByObjectService = (credentials) => {
    const http = new HttpService();
    let url = "users/update-progress-report-by-objects";
    const tokenId = "user-token";
    return http.postFormData(credentials, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;
    })
}

export const getApplicationService = (credentials) => {
    const http = new HttpService();
    let url = "users/view-application";
    const tokenId = "user-token";
    return http.postData(credentials, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}
export const getChalaniService = (credentials) => {
    const http = new HttpService();
    let url = "users/view-chalani";
    const tokenId = "user-token";
    return http.postData(credentials, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}
export const getProgressReportService = (credentials) => {
    const http = new HttpService();
    let url = "users/view-progress-report";
    const tokenId = "user-token";
    return http.postData(credentials, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}

export const ConfigChalaniService = () => {
    const http = new HttpService();
    let url = "customer/chalani/chalani-config";
    const tokenId = "user-token";

    return http.getDataAxios(url, tokenId).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}
export const ConfigProgressReportService = () => {
    const http = new HttpService();
    let url = "customer/progress-report/progress-report-config";
    const tokenId = "user-token";

    return http.getDataAxios(url, tokenId).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}